export const API_URL = "/api"
export const PAGE_SIZE = 20

export const NAMED_ENTITY_TYPES = [
  { value: "FORMAT", label: "Formato" },
  { value: "TYPOLOGY", label: "Tipologia" },
  { value: "AUTHOR", label: "Scrittore" },
  { value: "PHOTOGRAPHER", label: "Fotografo" },
  { value: "DESIGNER", label: "Cura e Design" },
  { value: "EDITOR", label: "Casa editrice" },
  { value: "COLLECTION", label: "Collana" }
]

export const MEDIA_TYPES = [
  { value: "IMAGE", label: "Immagine" },
  { value: "DOC", label: "Documento" },
]

export const RESOURCE_TYPOLOGIES = [
  { value: "VIDEO", label: "Video" },
  { value: "AUDIO", label: "Audio" },
  { value: "SAGGIO", label: "Saggio" },
  { value: "VOLUME", label: "Volume" },
  { value: "BIBLIOGRAFIA", label: "Bibliografia" },
]